import { FC, useContext } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import palette from '../../theme/palette';
import RK9Icon from '../../assets/images/RK9 Icon.png';
import { SessionContext } from '../../context/SessionContext';

interface RestrictedPageProps {
  isAlternate?: boolean;
  alternateTitle?: string;
  alternateTitleLine2?: string;
  alternateBody?: string;
}

export const RestrictedPage: FC<RestrictedPageProps> = (props) => {
  const { isAlternate, alternateTitle, alternateTitleLine2, alternateBody } = props;
  const {
    state: { user },
  } = useContext(SessionContext);

  return (
    <Grid
      sx={{
        position: 'absolute',
        inset: 0,
        display: isAlternate && !user ? 'none' : 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: { xs: 'center', md: 'flex-start' },
        alignItems: 'center',
        px: { xs: 2, md: 8 },
        background: `linear-gradient(rgba(255, 255, 255, 0.9), ${palette.disabled})`,
        zIndex: 9,
      }}
    >
      <Box
        component="img"
        src={RK9Icon}
        alt="Rogue K9 Logo"
        sx={{
          width: { xs: '100%', sm: '80%', md: '30%' },
          height: 'auto',
          maxWidth: { xs: '100vw', sm: '80vw', md: '50vw' },
          mr: { xs: 2, sm: 4, md: 6 },
          flexShrink: 0,
        }}
      />
      <Box sx={{ maxWidth: '500px' }}>
        <Typography variant="h1">Oops…</Typography>
        <Typography variant="h3">{alternateTitle || 'You must be logged in'}</Typography>
        <Typography variant="h3">{alternateTitleLine2 || 'to view these pages!'}</Typography>
        <Typography variant="h5" sx={{ mt: 2, fontWeight: 800 }}>
          {alternateBody || 'Please login to try again.'}
        </Typography>
      </Box>
    </Grid>
  );
};

export default RestrictedPage;
